export default __webpack_public_path__ + "static/home-sugar-free-raspberry-ribbon-ice-cream-e730a4de9342dd764d56b151d5aeb3d1.png";